import { performanceIncludesRun, type RunResult, type SurveyAnswers } from '@webapp2/shared/model'
import { post } from '@webapp2/shared/services/api'
import { state } from '../state'
import { currentUserCoursePerformance } from './course-service'

export function recordSurveyPrompt(runId: string) {
  const run = state.runResults[runId]
  if (!run || !isSurveyDue(run)) {
    return
  }
  void postRunSurvey(runId, {})
}

export async function submitSurvey(runId: string, answers: SurveyAnswers) {
  const response = await postRunSurvey(runId, answers)
  if (response.status === 204) {
    state.surveyAnswers[runId] = answers
  }
  return response
}

function postRunSurvey(runId: string, answers: SurveyAnswers) {
  const run = state.runResults[runId]!
  return post(`organization/${state.organizationId}/run/${runId}/survey`, {
    surveyDefinitionId: state.survey!.definitionId,
    courseId: run.courseId,
    prompted: isSurveyDue(run),
    answers
  })
}

export function isSurveyAvailable(run: RunResult | undefined): run is RunResult & { courseId: string } {
  return !!state.survey && !!run?.courseId && !run.multiplayerSessionId && !state.user?.isOsso
}

export function isSurveyDue(run: RunResult): boolean {
  const survey = state.survey
  if (!survey || !isSurveyAvailable(run)) {
    return false
  }
  return survey.cadence.includes(runNumber(run.id, run.courseId))
}

function runNumber(runLogId: string, courseId: string) {
  const performances = Object.values(state.userCoursePerformances)
  const countedRuns = performances.reduce((total, x) => total + x.totalRunCount, 0)
  const thisRunAlreadyCounted = performanceIncludesRun(currentUserCoursePerformance(courseId), runLogId)
  return countedRuns + (thisRunAlreadyCounted ? 0 : 1)
}
